import { AdPod } from './ad-pod';
import { SortedList } from './sorted-list';
import { AbstractAd } from '../ad/abstract';

export class AdBuffet {
    private _ads: SortedList<AbstractAd>;
    private _adPod: AdPod | null;
    constructor() {
        this._ads = new SortedList();
        this._adPod = null;
    }

    get ads() {
        return this._ads;
    }

    get adPod() {
        return this._adPod;
    }

    set adPod(value) {
        this._adPod = value;
    }

    get $type() {
        return 'AdBuffet';
    }
}
